export const AdminInfo = ({ formData, onChange, onSubmit, onPrevious }) => {
    return (
        <div className="w-full">
            <h2 className="text-2xl font-bold mb-4">Administrateur du compte Payor</h2>
            <p className="mb-6 text-gray-600">Novice ou non, vous bénéficiez chez nous d'un accompagnement sur mesure.</p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                    <label className="block text-gray-700 mb-2">Nom</label>
                    <input
                        type="text"
                        placeholder="Nom"
                        value={formData.lastName}
                        onChange={(e) => onChange('lastName', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                        required
                    />
                </div>
                <div>
                    <label className="block text-gray-700 mb-2">Prénom</label>
                    <input
                        type="text"
                        placeholder="prénom"
                        value={formData.firstName}
                        onChange={(e) => onChange('firstName', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                        required
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                    <label className="block text-gray-700 mb-2">Email</label>
                    <input
                        type="email"
                        placeholder="email"
                        value={formData.email}
                        onChange={(e) => onChange('email', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                        required
                    />
                </div>
                <div>
                    <label className="block text-gray-700 mb-2">Téléphone</label>
                    <input
                        type="tel"
                        placeholder="téléphone"
                        value={formData.phone}
                        onChange={(e) => onChange('phone', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                    <label className="block text-gray-700 mb-2">Mot de passe</label>
                    <input
                        type="password"
                        placeholder="********"
                        value={formData.password}
                        onChange={(e) => onChange('password', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                        required
                    />
                </div>
                <div>
                    <label className="block text-gray-700 mb-2">Confirmer mot de passe</label>
                    <input
                        type="password"
                        placeholder="********"
                        value={formData.confirmPassword}
                        onChange={(e) => onChange('confirmPassword', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                        required
                    />
                </div>
            </div>

            <div className="mb-8">
                <label className="block text-gray-700 mb-2">Votre poste</label>
                <select
                    value={formData.position}
                    onChange={(e) => onChange('position', e.target.value)}
                    className="input input-bordered w-full px-4 py-2 rounded"
                >
                    <option value="">Sélectionnez un poste</option>
                    <option value="PDG">PDG</option>
                    <option value="DRH">DRH</option>
                    <option value="DAF">DAF</option>
                    <option value="Comptable">Comptable</option>
                    <option value="Autre">Autre</option>
                </select>
            </div>
        </div>
    );
};